import { pxToRem } from '../../../../utils';
var toolbarMenuItemIconStyles = {
  root: function root(_ref) {
    var p = _ref.props;
    return Object.assign({}, p.hasContent && {
      marginRight: pxToRem(10)
    });
  }
};
export default toolbarMenuItemIconStyles;
//# sourceMappingURL=toolbarMenuItemIconStyles.js.map
